<!--<template>
    <div class="">
    <div>
      <div class="row">
        <!-- <div class="col-md-6 col-sm-7">
          <div class="card card-default widget animated">
            <div class="card-heading">
              <br/>
              <data-table :data="tableData" :columns="gridColumns" :filter-key="searchQuery"></data-table>
              <br/>
              <download-excel
                class   = "btn btn-default"
                :data   = "tableData"
                :fields = "gridColumns_export"
                name    = "report.csv">
              
                Download Excel
              
              </download-excel>
              <download-excel
                class   = "btn btn-default"
                :data   = "tableData"
                :fields = "gridColumns_export"
                name    = "report.csv">
              
                Download CSV
              
              </download-excel>
            </div>
          </div>
        </div> --
        <div class="col-md-6 col-sm-6">
          <div class="card card-default widget animated">
            <div class="card-heading">
              <br/>
              <data-table :data="tableData" :columns="gridColumns" :filter-key="searchQuery"></data-table>
              <br/>
              
            </div>
          </div>
        </div>
        <div class="col-md-5 col-sm-5">
          <div class="card card-default widget animated">
            <div class="card-heading">
              <div class="row">
                <div class="col-md-5">
                  <form-text label="Search" name="searchreports" v-model="searchQuery"></form-text>
                </div>
                <!--<div class="col-md-2">
                  <router-link to="/operations/workflows/create" class="btn btn-success">Add</router-link>
                </div> --
              </div>
              <br/>
              <reports-table :data="tableData" :columns="tableColumns" :filter-key="searchQuery"></reports-table>
              <br/>
              
            </div>
          </div>
        </div>
        <!-- <div class="col-md-5 col-sm-5">
          <div class="card card-default widget animated">
            <div class="card-heading">
              <p style="font-size:20px">Data Visualization is coming soon!</p>
            </div>
            <div class="card-body">
              <span class="btn-group" id="semiWorkingRadioGroup">
                <label class="btn btn-default" v-on:click="loginType = 'username'"><label type="radio">Table</label></label>
                <label class="btn btn-default" v-on:click="loginType = 'pie'"><label type="radio">Bar Chart</label></label>
                <label class="btn btn-default" v-on:click="loginType = 'password'"><label type="radio">Pie Chart</label></label>
              </span>

              <div v-if="loginType === 'username'">
                <label>Username</label>
                <input placeholder="Enter your username" key="username-input">
                <button type="button" v-on:click="loginType = 'password'" class="btn btn-danger btn-lg">Change</button>
              </div>
              <div v-else>
                <label>Email</label>
                <input placeholder="Enter your email address" key="email-input">
                <button type="button" v-on:click="loginType = 'username'" class="btn btn-danger btn-lg">Change</button>
              </div>

              

            </div>
          </div>
        </div>--><!-- /.col-md-12 --
      </div><!-- /.col-md-3 --
    </div>
  </div>
</template>

<script>
import DataTable from './DataTable';
import ReportsTable from './ReportsTable';
import FormText from '../elements/Form/FormText'

export default {
  name: 'datavisualization',
   components: {
    'data-table': DataTable,
    'reports-table': ReportsTable,
    'form-text': FormText,
    
  },
  data () {
    return {
      loginType: 'username',
      workflows: [],
      searchQuery: '',
      tableColumns: ['name', 'more'],
      tableColumns_export: {
        'name': "String"},
      gridColumns: ['name', 'age'],
      gridColumns_export: {
        'name': "String",
         'age': "String"},
      tableData: [
        {id:1, name:"John",age:"20"},
        {name:"Jane",age:"24"},
        {name:"Susan",age:"16"},
        {name:"Chris",age:"55"},
        {name:"Dan",age:"40"}
      ],
      options: {
      // see the options API 
      }
    }
  }
  
}
</script> -->

<template>
  <div class="">
    <div class="row">
      <div class="col-md-9 col-sm-9">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-5">
                <form-text label="Search Reports" name="searchreports" v-model="searchQuery"></form-text>
              </div>

            </div>
            <br/>
            <reports-table :data="reports" :columns="gridColumns" :filter-key="searchQuery"></reports-table>
          </div>
        </div>
      </div><!-- /.col-md-8 -->
    </div>
  </div>
</template>

<script>
import ReportsTable from './ReportsTable'
import FormText from '../elements/Form/FormText'
import database from '../webmaster/Database/database'
import reportsJson from './reports.json'
import store from '../webmaster/Store/vuex'

export default {
  name: 'workflows',
  components: {
    'reports-table': ReportsTable,
    'form-text': FormText
  },
  data () {
    return {
      loginType: 'username',
      reports: reportsJson,
      searchQuery: '',
      gridColumns: ['name', 'description', 'more'],
      org: store.state.usermain,
      gridColumns_export: {
        'name': "String"},
      options: {
      // see the options API 
      }
    }
  },
  /*computed: {
    filteredReports: function() {
      let userRole = this.org['curOrg']['role']

      if (userRole == 99) {
        return this.reports.reverse();
      }

      return this.reports.filter((report => report['.key'] < 4));
    }
  }, */
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// DataVisualization.vue?1e90fca8